// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import openrouteservice from 'openrouteservice-js';

export const getMapRoute = async (
	waypoints: [number, number][],
	profile = 'foot-walking',
	// Optional labels (e.g., stop title or id) parallel to waypoints — used only for diagnostics
	// when ORS rejects a coordinate. Pass them from the caller that has tour data.
	labels?: string[],
) => {
	try {
		if (waypoints.length < 2) return null;

		const Directions = new openrouteservice.Directions({
			api_key: '5b3ce3597851110001cf6248ad8483d00dbb489e958c465e60ca3baa',
		});

		const result = await Directions.calculate({
			coordinates: waypoints,
			profile,
			format: 'geojson',
		});

		return result;
	} catch (err: any) {
		// ORS error 2010 message contains "specified coordinate N: <lng> <lat>".
		// Pull N out so we can print which stop is the culprit.
		const raw = typeof err?.message === 'string' ? err.message : (typeof err === 'string' ? err : JSON.stringify(err));
		const match = raw.match(/coordinate\s+(\d+)\s*:\s*([\-\d.]+)\s+([\-\d.]+)/i);
		if (match) {
			const idx = parseInt(match[1], 10);
			const lng = match[2];
			const lat = match[3];
			const label = labels?.[idx] ?? '(unknown — pass labels[] to getMapRoute)';
			console.error(
				`[ORS] Stop at waypoint index ${idx} is not routable (${profile}). Coords: lng=${lng}, lat=${lat}. Label: "${label}".`,
				`\nFix options: move the stop a few meters onto a road, or extend the search radius via the radiuses parameter.`
			);
		} else {
			console.error('Route error:', err);
		}
		return null;
	}
}
